//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { EmailBuilderCustomizationActionType } from '@email-builder/actions/emailBuilderCustomizationActions';
import { EMAIL_BUILDER_ACTIONS } from '@email-builder/constants/emailBuilderConstants';
import {
  BUILDER_TYPES,
  FONT_CHOICES,
  IMAGE_LINK_DESTINATIONS,
  PRODUCT_OPTIONS,
} from '@email-builder/constants/emailBuilderConstants';
import { IEmailBuilderCustomization } from '@email-builder/models/emailBuilderStateModel';

const initialState: IEmailBuilderCustomization = {
  builderType: BUILDER_TYPES.EVERGREEN,
  dataSourceId: undefined,
  errors: {
    optionsErrors: {
      urlError: undefined,
    },
    layoutSettingsErrors: {
      numRowsError: undefined,
      numColumnsError: undefined,

      // TODO: Delete once we've moved to the responsive inputs
      imageHeightError: undefined,
      imageWidthError: undefined,
    },
    socialInformationErrors: {
      backgroundColorError: undefined,
      usernameTextColorError: undefined,
    },
    optionalFiltersErrors: {
      additionalFiltersError: undefined,
      categoryError: undefined,
      labelError: undefined,
      productIdError: undefined,
      productUrlError: undefined,
      tagError: undefined,
      usernameError: undefined,
    }
  },
  imageLink: IMAGE_LINK_DESTINATIONS.STATIC,
  isFilterUpdating: false,
  layoutSettings: {
    numRowsDesktop: 2,
    numColumnsDesktop: 4,
    useMobileLayout: true,
    numRowsMobile: 4,
    numColumnsMobile: 2,
    padding: 5,

    // TODO: Delete once we've moved to the responsive inputs
    imageHeight: 200,
    imageWidth: 200,
    numColumns: 3,
    numRows: 2,
  },
  mediaSources: [],
  optionalFilters: {
    additionalFilters: '',
    category: '',
    label: '',
    productId: '',
    productUrl: '',
    tag: '',
    username: '',
  },
  productOption: PRODUCT_OPTIONS.FIRST_PRODUCT,
  selectedMediaSource: undefined,
  socialInformation: {
    backgroundColor: '#ffffff',
    backgroundOpacity: 100,
    displayUsername: true,
    usernameFont: FONT_CHOICES.HELVETICA,
    usernameTextColor: '#000000',
  },
  url: '',
};

export default function EmailBuilderCustomizationReducer(
  state: IEmailBuilderCustomization = initialState,
  action: EmailBuilderCustomizationActionType,
): IEmailBuilderCustomization {
  switch (action.type) {
    case EMAIL_BUILDER_ACTIONS.UPDATE_OPTIONS: {
      return {
        ...state,
        [action.fieldKey]: action.value,
      };
    }
    case EMAIL_BUILDER_ACTIONS.SET_OPTIONS_ERROR: {
      return {
        ...state,
        errors: {
          ...state.errors,
          optionsErrors: {
            ...state.errors.optionsErrors,
            [`${action.fieldKey}Error`]: action.error,
          },
        },
      };
    }
    case EMAIL_BUILDER_ACTIONS.UPDATE_SOCIAL_INFORMATION: {
      return {
        ...state,
        socialInformation: {
          ...state.socialInformation,
          [action.fieldKey]: action.value,
        },
      };
    }
    case EMAIL_BUILDER_ACTIONS.SET_SOCIAL_INFORMATION_ERROR: {
      return {
        ...state,
        errors: {
          ...state.errors,
          socialInformationErrors: {
            ...state.errors.socialInformationErrors,
            [`${action.fieldKey}Error`]: action.error
          }
        },
      };
    }
    case EMAIL_BUILDER_ACTIONS.UPDATE_LAYOUT_SETTINGS: {
      return {
        ...state,
        layoutSettings: {
          ...state.layoutSettings,
          [action.fieldKey]: action.value,
        },
      };
    }
    case EMAIL_BUILDER_ACTIONS.SET_LAYOUT_SETTINGS_ERROR: {
      return {
        ...state,
        errors: {
          ...state.errors,
          layoutSettingsErrors: {
            ...state.errors.layoutSettingsErrors,
            [`${action.fieldKey}Error`]: action.error
          }
        },
      };
    }
    case EMAIL_BUILDER_ACTIONS.UPDATE_OPTIONAL_FILTERS: {
      return {
        ...state,
        optionalFilters: {
          ...state.optionalFilters,
          [action.fieldKey]: action.value,
        },
      };
    }
    case EMAIL_BUILDER_ACTIONS.SET_OPTIONAL_FILTERS_ERROR: {
      return {
        ...state,
        errors: {
          ...state.errors,
          optionalFiltersErrors: {
            ...state.errors.optionalFiltersErrors,
            [`${action.fieldKey}Error`]: action.error
          }
        },
      };
    }
    case EMAIL_BUILDER_ACTIONS.SET_MEDIA_SOURCES: {
      return {
        ...state,
        mediaSources: action.mediaSources,
      };
    }
    case EMAIL_BUILDER_ACTIONS.SET_DATA_SOURCE_ID: {
      return {
        ...state,
        dataSourceId: action.dataSourceId,
      };
    }
    case EMAIL_BUILDER_ACTIONS.SET_FILTER_UPDATING: {
      return {
        ...state,
        isFilterUpdating: action.isFilterUpdating,
      };
    }
    default:
      return state;
  }
}
